import type { PrivacyRequest, PrivacyRequestKind } from 'shared';

/** Who is responsible for the data (responsável pelo tratamento). */
export const PRIVACY_CONTROLLER = 'CDI Portugal';

/**
 * Where to write about personal data. null until CDI Portugal names the
 * address; the page then says it is still to be set.
 */
export const PRIVACY_EMAIL: string | null = 'jose.ribeiro@cdi.org.pt';

/** When the Privacidade page last changed, "YYYY-MM-DD". */
export const PRIVACY_UPDATED = '2026-10-15';

export const REQUEST_LABEL: Record<PrivacyRequestKind, string> = {
  copy: 'Cópia dos meus dados',
  erasure: 'Eliminar a minha conta',
};

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('pt-PT', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'Europe/Lisbon',
  });
}

/** The day a "YYYY-MM-DD" date names, written out. */
export function formatDay(day: string): string {
  return formatDate(`${day}T12:00:00Z`);
}

/** Where a request stands, in one line. */
export function requestStatus(request: PrivacyRequest): string {
  if (request.handledAt) return `Tratado a ${formatDate(request.handledAt)}`;
  return `Enviado a ${formatDate(request.createdAt)} · resposta até ${formatDate(request.dueAt)}`;
}

/** The person's open request of this kind, if they have one. */
export function openRequest(
  requests: ReadonlyArray<PrivacyRequest>,
  kind: PrivacyRequestKind,
): PrivacyRequest | undefined {
  return requests.find((r) => r.kind === kind && r.handledAt === null);
}
